import * as Sentry from "@sentry/react-native";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStore } from "~/mobx/utils/useStore";

export const RefreshToken = observer(function RefreshToken() {
  const store = useStore();

  useEffect(() => {
    const id = setInterval(async () => {
      try {
        await store.authStore.updateTokens();
      } catch (error) {
        Sentry.captureException(error);
        console.log("🔑 Error refreshing token: ", error);
      }
    }, 5000);

    return () => {
      console.log("🔑 Clearing interval");
      clearInterval(id);
    };
  }, [store.authStore]);

  return null;
});
